<template>
  <div class="v2-model-item" :class="theme">
    <div class="thumb" :class="borderClass">
      <like-button @click="signupButtonClick" />
      <a href="#" class="ratio d-block" @click.prevent="signupLinkClick">
        <img v-lazy="thumb" :alt="`${model[`name_${locale}`]} photo`" fetchpriority="high" />
      </a>
    </div>

    <a href="#" class="name" @click.prevent="signupLinkClick">
      {{ model[`name_${locale}`] }}
    </a>

    <div class="location">
      {{ model[`location_${locale}`] }}
    </div>
    <p class="mb-3">
      {{ model[`public_description_${locale}`] }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from "vue";
import { useModalStore } from "@/store/modal";
import { useI18n } from "vue-i18n";
import { getModelThumb, getPublicModelThumb } from "@/utils/mediaHelper";
import LikeButton from "@/components/v2/like-button/index.vue";
import { amplitudeButtonClickTrack, amplitudeTrack } from "@/utils/amplitude";
import { Model } from "@/interfaces/Model/Model.ts";

defineOptions({
  name: "model-item",
});

const props = defineProps({
  model: {
    type: Object as PropType<Model>,
    require: true,
    default: null,
  },
  index: {
    type: Number,
    require: true,
    default: 1,
  },
  theme: {
    type: String,
    required: false,
    default: "light",
    validator: (value: string) => {
      return ["light", "dark"].includes(value);
    },
  },
});

const modalStore = useModalStore();
const { locale } = useI18n();

const thumb = computed(() => {
  return props.model.thumbnail_public
    ? getPublicModelThumb(props.model.thumbnail_public, 442, 660, false)
    : getModelThumb(props.model.thumbnail as string, 442, 660);
});
const profileUrl = computed(() => `/profile/${props.model.id}`);

const borderClass = computed(() => {
  switch ((props.index + 1) % 4) {
    case 0:
      return "border-orange";
    case 1:
      return "border-mint";
    case 2:
      return "border-pink";
    default:
      return "border-lilac";
  }
});

const signupLinkClick = () => {
  amplitudeTrack("freearea model item click", { "Model ID": props.model.id });
  modalStore.showModal({ id: "modal-signup", redirectUrl: profileUrl.value });
};

const signupButtonClick = () => {
  amplitudeButtonClickTrack("like click", props.model.id);
  modalStore.showModal({ id: "modal-signup", redirectUrl: profileUrl.value });
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
